import type { CampaignCommon } from '../declarations/campaign';
import type { DeepReadonly } from '../declarations/deep-readonly';

export const getCampaignSkipIdentifier = (c: CampaignCommon | DeepReadonly<CampaignCommon>): string =>
  (c.adminId?.toString() || c.partnerId)!;
